import _ from 'lodash';

import { PAGE_CODES } from 'constants/pageCodes';
import { getDefaultErrorMessage } from 'utils/axios';

import { SKYNET_INTERNAL_COMPANY_ID } from './authRoles';

export const INTERNAL_COMPANY_HIDDEN_PAGES = [
  PAGE_CODES.ELIGIBILITY_BUILDER,
  PAGE_CODES.ESCROW_REQUIREMENTS,
  PAGE_CODES.ADJUSTMENTS,
];

export const checkIsInternalCompany = ({ companyId }) => companyId === SKYNET_INTERNAL_COMPANY_ID;

export const checkIsGlobalRole = role => role.isGlobal ?? checkIsInternalCompany(role);

// signInWithToken rejects with the unwrapped response body for axios failures (e.g. `{ error: {...} }`)
// but with a `{ response }` envelope otherwise, so both shapes are re-wrapped for getDefaultErrorMessage.
// An object reaching AlertsCDS as `message` throws during render and strands the app on the splash.
export const getSignInErrorMessage = error => {
  if (_.isString(error) && error) {
    return error;
  }

  const message = getDefaultErrorMessage(error?.response ? error : { response: { data: error } });

  return _.isArray(message) ? message.join(' ') : String(message);
};
